import { useEffect } from "react";
import { trpc } from "utils/trpc";
import { useRouter } from "next/router";
import { setProjectSessionId } from "./project-session-storage";

type Props = {
  pageId?: string;
  onProjectSessionInit?: (sessionId: string) => void;
  suspense?: boolean;
};

export function useProjectSessionInit(props?: Props) {
  const router = useRouter();

  const query = trpc.projectAuth.sessionInit.useQuery(
    { path: router.asPath, pageId: props?.pageId },
    {
      enabled: router.isReady,
      suspense: props?.suspense ?? false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  useEffect(() => {
    if (typeof window !== "undefined" && query.data?.sessionId) {
      setProjectSessionId(query.data.sessionId);
      props?.onProjectSessionInit?.(query.data.sessionId);
    }
  }, [props, query.data?.sessionId]);

  return query;
}
